import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map } from 'rxjs/operators';
import { cancelConditionsActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of, switchMap } from 'rxjs';
import { CancelConditionsService } from '../../services/cancel-conditions.service';

@Injectable({
  providedIn: 'root',
})
export class CancelConditionsEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private cancelConditionsService: CancelConditionsService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cancelConditionsActions.findAll),
      switchMap(() => {
        return this.cancelConditionsService.findAll().pipe(
          map((response) =>
            cancelConditionsActions.findAllSuccess({
              cancelConditions: response.data,
            }),
          ),
          catchError((error: ApiError) =>
            of(
              cancelConditionsActions.findAllError({
                error: error.message,
              }),
            ),
          ),
        );
      }),
    ),
  );
}
